import { isDefinedString } from "et3-type-guards";
import i18n from "../../../../../../constants/i18n";
import Et3Image from "../../../../../../core/et3-Image";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import getKhattabatSharedMessagingStore from "../../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";
import getKhattabat101MessagingStore from "../../../../../../stores/khattabat-stores/messaging-stores/101-messaging-store";
import getKhattabat102MessagingStore from "../../../../../../stores/khattabat-stores/messaging-stores/102-messaging-store";

const SendMessageButton = withLiteObserverAndTheme<{
  conversationID: string;
}>((props) => {
  const { theme, conversationID } = props;
  const { colors, unitX } = theme;
  const conversationType =
    getKhattabatSharedMessagingStore(conversationID).conversationType.get();
  const isOneOOneCComment = conversationType === "101C_COMMENTS";

  const { messageField, isSending } =
    getKhattabatSharedMessagingStore(conversationID);
  const shouldSend = isDefinedString(messageField.get()) && !isSending.get();

  const buttonText = isOneOOneCComment ? "ADD" : "SEND";
  const buttonColor = !shouldSend
    ? colors.all.gray
    : isOneOOneCComment
      ? colors.all.red
      : colors.all.bondiBlue;
  return (
    <ET3Div
      width={108}
      height={40}
      alignItems={"center"}
      fDirection={"row"}
      justifyContent={"center"}
      style={{
        backgroundColor: buttonColor,
        borderRadius: 41 * unitX,
        cursor: "pointer"
      }}
      color={""}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {
        conversationType === "102"
          ? getKhattabat102MessagingStore(conversationID).sendMessage()
          : getKhattabat101MessagingStore(conversationID).sendMessage();
      }}
    >
      <Et3Text
        fontFamily={"LIGHT"}
        fontSize={18}
        isSpan={false}
        text={i18n.get(buttonText)}
        style={{}}
        color={colors.all.white}
      />
      <Et3Margin left={1} right={1} top={0} bottom={0} />
      <Et3Image
        type="LOCAL"
        alt={i18n.get(buttonText)}
        imageName={"send"}
        size={18}
        onClick={() => {}}
        style={{}}
      />
    </ET3Div>
  );
});

export default SendMessageButton;
